import assign = require("core-js/library/fn/object/assign");
import { AnswerPartPreview, AnswerPartPreviewResponse, AnswerPartPreviewStandalone } from "../../../react/CalcPad/apimodels/AnswerPart";
import { CPAssignmentBuilderInitializeRequest, CPAssignmentBuilderInitializeResponse } from "../../../react/CalcPad/apimodels/AssignmentBuilderInitialize";
import { CPAssignmentBuilderSet, CPAssignmentBuilderSetRequest, CPAssignmentBuilderSetResponse } from "../../../react/CalcPad/apimodels/AssignmentBuilderSet";
import { CalcPadBaseResponse } from "../../../react/CalcPad/apimodels/CalcPadBaseResponse";
import { CPProblemSearch, CPProblemSearchRequest, CPProblemSearchResponse } from "../../../react/CalcPad/apimodels/CPProblemSearch";
import { GetAssignmentRequest, GetAssignmentResponse } from "../../../react/CalcPad/apimodels/DisplayAssignment";
import { GetProblemTagsResponse } from "../../../react/CalcPad/apimodels/GetProblemTags";
import { GetProblemTopicsResponse } from "../../../react/CalcPad/apimodels/GetProblemTopics";
import { PreviewProblemRequest, PreviewProblemResponse } from "../../../react/CalcPad/apimodels/PreviewProblem";
import { CPProblemBuilderInitialize, CPProblemBuilderInitializeByGuidRequest, CPProblemBuilderInitializeRequest, CPProblemBuilderInitializeResponse } from "../../../react/CalcPad/apimodels/ProblemBuilderInitialize";
import { CPProblemBuilderSet, CPProblemBuilderSetRequest } from "../../../react/CalcPad/apimodels/ProblemBuilderSet";
import { RemovePartInstanceRequest } from "../../../react/CalcPad/apimodels/RemovePartInstance";
import { RemoveProblemInstanceRequest } from "../../../react/CalcPad/apimodels/RemoveProblemInstance";
import { RetireProblemRequest } from "../../../react/CalcPad/apimodels/RetireProblemRequest";
import { GetProblemsByGuidRequest, GetProblemsByGuidResponse } from "../../../react/CalcPad/apimodels/GetProblemsByGuid"
import { ValidateAssignmentResponse, ValidateEquationRequest, ValidateEquationResponse, ValidateProblemResponse } from "../../../react/CalcPad/apimodels/Validate";
import { CPReactMethods } from "../../../react/CalcPad/app";
import { CPAssignment } from "../../../react/CalcPad/models/CPAssignment";
import { CPPart } from "../../../react/CalcPad/models/CPPart";
import { CPProblem } from "../../../react/CalcPad/models/CPProblem";
import { CPVariable } from "../../../react/CalcPad/models/CPVariable";
import { AjaxHelper } from "../../SharedLibrary/AjaxHelper";

// declare so we can reference the methods without importing the ACTUAL class.
declare global {
    interface Window {
        CPReactMethods: CPReactMethods
    }
}

export class CPInstructorMethods {
    public CPInstructorMethods() {

    }

    /* React Launch */
    public editAssignment(container: HTMLDivElement, assignmentId: number, taskPartId?: number): void {
        this.getAssignment(assignmentId, taskPartId).then(response => {
            window.CPReactMethods.launchAssignmentBuilder(container, response.data, response.helpText, response.limitedEditing, response.isSharedAssignment, response.problemLimitEditing, response.problemUserIsOwner, response.problemInMultiplePlaces, response.problemAnsweredInAssignment, response.courseGuid);
        }).catch((error) => {
            alert(error);
        });
    }

    public editNewProblem(container: HTMLDivElement, problemTopicEntityId?: number): void {
        this.getNewProblem(problemTopicEntityId).then(response => {
            window.CPReactMethods.launchProblemBuilder(container, response.data, response.userIsOwner, response.limitedEditing, false, true);
        }).catch((error) => {
            alert(error);
        });
    }

    public editExistingProblem(container: HTMLDivElement, id?: number, instanceId?: number, taskPartConfigurationId?: number): void {
        this.getProblem(id, instanceId, taskPartConfigurationId).then(response => {
            window.CPReactMethods.launchProblemBuilder(container, response.data, response.userIsOwner, response.limitedEditing, response.inMultiplePlaces, true);
        }).catch((error) => {
            alert(error);
        });
    }

    public launchProblemLibrary(container: HTMLDivElement, topic: string) {
        window.CPReactMethods.launchProblemLibrary(container, topic)
    }

    public previewAssignment(container: HTMLDivElement, assignmentId: number, courseGuid?: string): Promise<void | GetAssignmentResponse> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: GetAssignmentRequest = {
            assignmentId,
            courseGuid
        };
        window.toasts = window.GlobalMethods.AddToast(window.toasts, "loadingAssignment", "Loading Assignment");
        window.GlobalMethods.ShowToast(window.toasts, "loadingAssignment")
        return ajax.postRequest<GetAssignmentResponse>("/api/tasktracker/calcpad/GetAssignment", request)
            .then(response => {
                window.GlobalMethods.HideToast(window.toasts, "loadingAssignment")
                if (!response.successful) {
                    throw new Error(response.message);
                }
                window.CPReactMethods.launchAssignmentDisplay(container, response.data)
            });
    }

    public previewProblem(container: HTMLDivElement, problemGuid: string): Promise<void | PreviewProblemResponse> {
        const ajax = new AjaxHelper();

        // Get Problem
        let request: PreviewProblemRequest = {
            problemGuid
        };
        return ajax.postRequest<PreviewProblemResponse>("/api/tasktracker/calcpad/PreviewProblem", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                window.CPReactMethods.launchProblemDisplay(container, response.data);
            });
    }

    public previewMyProblem(container: HTMLDivElement, problemInstanceId: number, courseGuid: string): Promise<void | PreviewProblemResponse> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: PreviewProblemRequest = {
            problemInstanceId,
            courseGuid
        };
        return ajax.postRequest<PreviewProblemResponse>("/api/tasktracker/calcpad/PreviewProblem", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                window.CPReactMethods.launchProblemDisplay(container, response.data, courseGuid)
            });
    }

    /* Data Retrieval */
    public getAssignment(assignmentId: number, taskPartId?: number): Promise<CPAssignmentBuilderInitializeResponse> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: CPAssignmentBuilderInitializeRequest = {
            id: assignmentId,
            taskPartId
        };
        return ajax.postRequest<CPAssignmentBuilderInitializeResponse>("/api/tasktracker/calcpad/AssignmentBuilderInitialize", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public getProblem(id?: number, instanceId?: number, taskPartConfigurationId?: number, assignmentId?: number): Promise<CPProblemBuilderInitialize> {
        const ajax = new AjaxHelper();

        // Empty Initialize request
        let request: CPProblemBuilderInitializeRequest = {
            id,
            instanceId,
            taskPartConfigurationId,
            assignmentId,
        };
        return ajax.postRequest<CPProblemBuilderInitializeResponse>("/api/tasktracker/calcpad/ProblemBuilderInitialize", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public getProblemByGuid(guid: string, assignmentId?: number, order?: number): Promise<CPProblemBuilderInitialize> {
        const ajax = new AjaxHelper();

        // Empty Initialize request
        let request: CPProblemBuilderInitializeByGuidRequest = {
            guid,
            assignmentId,
            order,
        };
        return ajax.postRequest<CPProblemBuilderInitializeResponse>("/api/tasktracker/calcpad/ProblemBuilderInitializeByGuid", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public getProblemsByGuid(guids: Array<string>, assignmentId?: number, order?: number): Promise<GetProblemsByGuidResponse> {
        const ajax = new AjaxHelper();


        let request: GetProblemsByGuidRequest = {
            guids,
            assignmentId,
            order,
        }

        return ajax.postRequest<GetProblemsByGuidResponse>("/api/tasktracker/calcpad/GetProblemsByGuid", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public getNewProblem(problemTopicEntityPartId?: number, problemTaskPartConfigurationId?: number): Promise<CPProblemBuilderInitialize> {
        const ajax = new AjaxHelper();

        // Empty Initialize request
        let request: CPProblemBuilderInitializeRequest = {
            topicTaskEntityId: problemTopicEntityPartId,
            taskPartConfigurationId: problemTaskPartConfigurationId,
        };
        return ajax.postRequest<CPProblemBuilderInitializeResponse>("/api/tasktracker/calcpad/ProblemBuilderInitialize", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public findProblems(searchParams: CPProblemSearchRequest): Promise<CPProblemSearch> {
        const ajax = new AjaxHelper();

        return ajax.postRequest<CPProblemSearchResponse>("/api/tasktracker/calcpad/FindProblems", searchParams)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }


    /* Data Save */
    public setAssignment(assignment: CPAssignment, clone?: boolean, delink?: boolean): Promise<CPAssignmentBuilderSet> {
        const ajax = new AjaxHelper();

        let request: CPAssignmentBuilderSetRequest = {
            data: assignment,
            clone: clone,
            delink: delink
        };
        return ajax.postRequest<CPAssignmentBuilderSetResponse>("/api/tasktracker/calcpad/AssignmentBuilderSet", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public cloneProblem(problemId: number): Promise<CPProblemBuilderSet> {
        return this.getProblem(problemId).then(response => {
            return this.setProblem(response.data, true, true);
        });
    }

    public setProblem(problem: CPProblem, clone: boolean, isStandAloneProblem: boolean, assignmentId?: number): Promise<CPProblemBuilderSet> {
        const ajax = new AjaxHelper();

        let request: CPProblemBuilderSetRequest = {
            data: problem,
            clone,
            standAloneProblem: isStandAloneProblem,
            assignmentId
        };
        return ajax.postRequest<CPProblemBuilderInitializeResponse>("/api/tasktracker/calcpad/ProblemBuilderSet", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public retireProblem(request: RetireProblemRequest): Promise<boolean> {
        const ajax = new AjaxHelper();

        return ajax.postRequest<CalcPadBaseResponse>("/api/tasktracker/calcpad/RetireProblem", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response.successful;
            });
    }

    public removeProblemInstance(assignmentId: number, problemInstanceId: number, updatedGradedPoints?: number): Promise<boolean> {
        const ajax = new AjaxHelper();

        let request: RemoveProblemInstanceRequest = {
            assignmentId,
            problemInstanceId,
            updatedGradedPoints
        }
        return ajax.postRequest<CalcPadBaseResponse>("/api/tasktracker/calcpad/RemoveProblemInstance", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response.successful;
            });
    }

    public removePartInstance(partInstanceId: number, updatedGradedPoints?: number): Promise<boolean> {
        const ajax = new AjaxHelper();

        let request: RemovePartInstanceRequest = {
            partInstanceId,
            updatedGradedPoints
        }
        return ajax.postRequest<CalcPadBaseResponse>("/api/tasktracker/calcpad/RemovePartInstance", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response.successful;
            });
    }


    /* Misc Data retrieval */
    public getProblemTags(): Promise<Array<string>> {
        const ajax = new AjaxHelper();
        return ajax.getRequest<GetProblemTagsResponse>("/api/tasktracker/calcpad/GetProblemTags")
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response.tags;
            });
    }

    public getProblemTopics(): Promise<Array<{ label: string, value: { codename: string, guid: string } }>> {
        const ajax = new AjaxHelper();
        return ajax.getRequest<GetProblemTopicsResponse>("/api/tasktracker/calcpad/GetProblemTopics")
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response.topics;
            })
    }

    // Called for previewProblem, if you use previewMyProblem then answer with CPmethods.AnswerProblem
    public answerPartPreview(problemInstanceId: number, partInstanceId: number, seed: number, answer: number, exponent?: number): Promise<AnswerPartPreviewResponse> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: AnswerPartPreview = {
            problemInstanceId,
            partInstanceId,
            seed,
            answer,
            exponent: exponent ?? 0
        };
        return ajax.postRequest<AnswerPartPreviewResponse>("/api/tasktracker/calcpad/AnswerPartPreview", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    // Called for previewProblem, if you use previewMyProblem then answer with CPmethods.AnswerProblem
    public answerPartPreviewStandalone(problemGuid: string, partId: number, seed: number, answer: number, exponent?: number): Promise<AnswerPartPreviewResponse> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: AnswerPartPreviewStandalone = {
            problemGuid,
            partId,
            seed,
            answer,
            exponent: exponent ?? 0
        };
        return ajax.postRequest<AnswerPartPreviewResponse>("/api/tasktracker/calcpad/AnswerPartPreviewStandalone", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }

    public async checkAssignment(assignment: CPAssignment, totalPoints: number): Promise<ValidateAssignmentResponse> {
        var validateAssignmentResponse: ValidateAssignmentResponse = {
            valid: true,
            successful: true,
            message: ""
        }

        if (assignment.gradedPoints != undefined && assignment.gradedPoints > totalPoints) {
            validateAssignmentResponse.valid = false;
            validateAssignmentResponse.message = "Assignment possible points is less than assignment point value override."
        }

        if (this.isNullOrWhiteSpace(assignment.name)) {
            validateAssignmentResponse.valid = false;
            validateAssignmentResponse.message = "Assignment is missing a name."
        }
        for (var problem of assignment.problems) {
            if (validateAssignmentResponse.valid) {
                await this.checkProblem(problem).then(response => {
                    if (!response.valid || !response.successful) {
                        validateAssignmentResponse.valid = false
                        validateAssignmentResponse.message = response.message
                    }
                }).catch((error) => {
                    validateAssignmentResponse.valid = false
                    validateAssignmentResponse.message = error
                })
            }
        }

        return validateAssignmentResponse
    }

    public async checkProblem(problem: CPProblem): Promise<ValidateProblemResponse> {
        var validateProblemResponse: ValidateProblemResponse = {
            valid: true,
            successful: true,
            message: ""
        }

        if (validateProblemResponse.valid && this.isNullOrWhiteSpace(problem.name)) {
            validateProblemResponse.valid = false;
            validateProblemResponse.message = "Problem must have a name."
        }
        if (validateProblemResponse.valid && this.isNullOrWhiteSpace(problem.text)) {
            validateProblemResponse.valid = false;
            validateProblemResponse.message = "Problem must have problem text."
        }

        var testVariablesForSameName: Array<CPVariable> = []
        problem.variables.forEach(variable => {
            if (validateProblemResponse.valid && variable.name == "g") {
                validateProblemResponse.valid = false
                validateProblemResponse.message = "The variable name g is a global variable and can't be used for a custom variable."
            }
            if (validateProblemResponse.valid && testVariablesForSameName.find(v => v.name == variable.name)) {
                validateProblemResponse.valid = false
                validateProblemResponse.message = "All variables need to have a unique name."
            }
            testVariablesForSameName.push(variable)
            if (validateProblemResponse.valid && this.isNullOrWhiteSpace(variable.name)) {
                validateProblemResponse.valid = false
                validateProblemResponse.message = "All variables need to have a name."
            }
            variable.es.forEach(exclusion => {
                if (validateProblemResponse.valid && parseFloat(exclusion.min.toString()) > parseFloat(exclusion.max.toString())) {
                    validateProblemResponse.valid = false
                    validateProblemResponse.message = "All exclusions must have a min that is less than or equal to their max."
                }
            })
            variable.rs.forEach(range => {
                if (validateProblemResponse.valid && parseFloat(range.min.toString()) > parseFloat(range.max.toString())) {
                    validateProblemResponse.valid = false
                    validateProblemResponse.message = "All ranges must have a min that is less than or equal to their max."
                }
                if (validateProblemResponse.valid && parseFloat(range.inc.toString()) <= 0) {
                    validateProblemResponse.valid = false
                    validateProblemResponse.message = "All ranges must have an increment that is greater than or equal to zero."
                }
            })
            if (validateProblemResponse.valid && !variable.isDependent) {
                try {
                    this.checkVariableForPossibleValues(variable)
                }
                catch (error) {
                    validateProblemResponse.valid = false
                    // @ts-ignore
                    validateProblemResponse.message = error
                }
            }
        })

        problem.variables.forEach(variable => {
            if (validateProblemResponse.valid && variable.isDependent) {
                if (this.isNullOrWhiteSpace(variable.calculation)) {
                    validateProblemResponse.valid = false
                    validateProblemResponse.message = "Dependent variable " + variable.name + " is missing a calculation."
                }
                if (this.isNullOrUndefined(variable.precision)) {
                    validateProblemResponse.valid = false
                    validateProblemResponse.message = "Dependent variable " + variable.name + " is missing a precision."
                }
                this.checkDependentVariableCalculation(variable, problem.variables)
            }
        })

        try {
            if (validateProblemResponse.valid) {
                this.checkProblemTextForVariableNames(problem, problem.variables)
            }
        }
        catch (error) {
            validateProblemResponse.valid = false
            // @ts-ignore
            validateProblemResponse.message = error
        }
        problem.links.forEach(link => {
            if (validateProblemResponse.valid && this.isNullOrWhiteSpace(link.url)) {
                validateProblemResponse.valid = false
                validateProblemResponse.message = "All links must have a url."
            }
        })
        for (var part of problem.parts) {
            if (validateProblemResponse.valid) {
                await this.checkPart(part, problem).then(response => {
                    if (!response.successful) {
                        validateProblemResponse.valid = false;
                        validateProblemResponse.message = response.message
                    }
                }).catch((error) => {
                    validateProblemResponse.valid = false
                    validateProblemResponse.message = error
                })
            }
        }
        return validateProblemResponse;
    }

    public checkPart(part: CPPart, problem: CPProblem): Promise<ValidateEquationResponse> {
        this.checkEquationForVariableNames(part, problem.variables)
        this.checkPartTextForVariableNames(part, problem.variables)
        if (!this.isNullOrWhiteSpace(part.answerLabel)) {
            if (part.answerLabel.length > 200) {
                throw "Problem part " + String.fromCharCode(96 + part.order) + "'s answer label is too long. Reduce the number of characters or remove styling."
            }
        }
        if (!this.isNullOrWhiteSpace(part.unitsLabel)) {
            if (part.unitsLabel.length > 200) {
                throw "Problem part " + String.fromCharCode(96 + part.order) + "'s units label is too long. Reducte the number of characters or remove styling."
            }
        }
        if (part.multipleChoice) {
            if (part.options == undefined || part.options.length <= 1) {
                throw 'Problem part ' + String.fromCharCode(96 + part.order) + ' is multiple choice, but has one or less options. All multiple choice parts must have at least two options.'
            }
            else {
                part.options.forEach(option => {
                    if (this.isNullOrWhiteSpace(option.text)) {
                        throw 'Problem part ' + String.fromCharCode(96 + part.order) + ' has an option without display text.'
                    }
                    if (this.isNullOrWhiteSpace(option.value.toString())) {
                        throw 'Problem part ' + String.fromCharCode(96 + part.order) + ' has an option without a value.'
                    }
                    if (isNaN(parseFloat(option.value.toString()))) {
                        throw 'Problem part ' + String.fromCharCode(96 + part.order) + ' has an option with a non number value. All option values must be numbers.'
                    }
                })
            }
        }
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: ValidateEquationRequest = {
            problem: problem,
            equation: part.equation,
            calculateAsDouble: part.calculateAsDouble
        };
        return ajax.postRequest<ValidateEquationResponse>("/api/tasktracker/calcpad/ValidateEquation", request)
            .then(response => {
                return response
            });
    }

    private checkVariableForPossibleValues(variable: CPVariable) {
        var possibleValues: Array<number> = []
        variable.rs.forEach(range => {
            for (var value = parseFloat(range.min.toString()); value <= parseFloat(range.max.toString()); value += parseFloat(range.inc.toString())) {
                possibleValues.push(value)
            }
        })
        variable.es.forEach(exclusion => {
            possibleValues.forEach((value, valueIndex) => {
                if (value <= parseFloat(exclusion.max.toString()) && value >= parseFloat(exclusion.min.toString())) {
                    possibleValues.splice(valueIndex, 1)
                }
            })
        })
        if (possibleValues.length == 0) {
            throw "Variable " + variable.name + "'s ranges and exclusions do not create any possible values."
        }
    }

    private checkDependentVariableCalculation(checkedVariable: CPVariable, variables: Array<CPVariable>) {
        var openBracketIndexes: Array<number> = []
        var closedBracketIndexes: Array<number> = []
        for (let index = 0; index < checkedVariable.calculation!.length; index++) {
            if (checkedVariable.calculation![index] === '[') {
                openBracketIndexes.push(index);
            }
            else {
                if (checkedVariable.calculation![index] === ']') {
                    closedBracketIndexes.push(index)
                }
            }
        }
        if (openBracketIndexes.length != closedBracketIndexes.length) {
            throw "Dependent variable " + checkedVariable.name + "'s calculation has mismatching brackets in it resulting in incorrect variable names."
        }
        openBracketIndexes.forEach((value, index) => {
            if (closedBracketIndexes[index] < value) {
                throw "Dependent variable " + checkedVariable.name + "'s calculation has mismatching brackets in it resulting in incorrect variable names."

            }
            var independentVariableName = checkedVariable.calculation!.substring(value + 1, closedBracketIndexes[index])
            let foundIndependentVariableName = false
            if (independentVariableName == "g") {
                foundIndependentVariableName = true
            }
            if (!foundIndependentVariableName) {
                for (let i = 0; i < variables.length; i++) {
                    if (!variables[i].isDependent && variables[i].name == independentVariableName) {
                        foundIndependentVariableName = true
                        break
                    }
                }
            }
            if (!foundIndependentVariableName) {
                throw "Dependent variable " + checkedVariable.name + " contains an invalid variable name. Only independent variable names are valid. Variable names are case sensititve"
            }
        })
    }

    private checkProblemTextForVariableNames(checkedProblem: CPProblem, variables: Array<CPVariable>) {
        var openBracketIndexes: Array<number> = []
        var closedBracketIndexes: Array<number> = []
        for (let index = 0; index < checkedProblem.text!.length; index++) {
            if (checkedProblem.text![index] === '[') {
                openBracketIndexes.push(index);
            }
            else {
                if (checkedProblem.text![index] === ']') {
                    closedBracketIndexes.push(index)
                }
            }
        }
        if (openBracketIndexes.length != closedBracketIndexes.length) {
            throw 'Problem ' + checkedProblem.order + "'s text has mismatching brackets in it resulting in incorrect variable names."
        }
        openBracketIndexes.forEach((value, index) => {
            if (closedBracketIndexes[index] < value) {
                throw 'Problem ' + checkedProblem.order + "'s text has mismatching brackets in it resulting in incorrect variable names."

            }
            var variableName = checkedProblem.text!.substring(value + 1, closedBracketIndexes[index])
            let foundVariableName = false
            if (variableName == "g") {
                foundVariableName = true
            }
            if (!foundVariableName) {
                for (let i = 0; i < variables.length; i++) {
                    if (variables[i].name == variableName) {
                        foundVariableName = true
                        break
                    }
                }
            }
            if (!foundVariableName) {
                throw 'Problem ' + checkedProblem.order + "'s text contains an invalid variable name. Variable names are case sensitive."
            }
        })
    }

    private checkEquationForVariableNames(checkedPart: CPPart, variables: Array<CPVariable>) {
        var openBracketIndexes: Array<number> = []
        var closedBracketIndexes: Array<number> = []
        for (let index = 0; index < checkedPart.equation!.length; index++) {
            if (checkedPart.equation![index] === '[') {
                openBracketIndexes.push(index);
            }
            else {
                if (checkedPart.equation![index] === ']') {
                    closedBracketIndexes.push(index)
                }
            }
        }
        if (openBracketIndexes.length != closedBracketIndexes.length) {
            throw 'Problem part ' + String.fromCharCode(96 + checkedPart.order) + "'s equation has mismatching brackets in it resulting in incorrect variable names."
        }
        openBracketIndexes.forEach((value, index) => {
            if (closedBracketIndexes[index] < value) {
                throw 'Problem part ' + String.fromCharCode(96 + checkedPart.order) + "'s equation has mismatching brackets in it resulting in incorrect variable names."

            }
            var variableName = checkedPart.equation!.substring(value + 1, closedBracketIndexes[index])
            let foundVariableName = false
            if (variableName == "g") {
                foundVariableName = true
            }
            if (!foundVariableName) {
                for (let i = 0; i < variables.length; i++) {
                    if (variables[i].name == variableName) {
                        foundVariableName = true
                        break
                    }
                }
            }
            if (!foundVariableName) {
                throw 'Problem part ' + String.fromCharCode(96 + checkedPart.order) + "'s equation contains an invalid variable name [" + variableName + "]. Variable names are case sensitive."
            }
        })
    }

    private checkPartTextForVariableNames(checkedPart: CPPart, variables: Array<CPVariable>) {
        var openBracketIndexes: Array<number> = []
        var closedBracketIndexes: Array<number> = []
        var textLength = checkedPart.text?.length ?? 0
        for (let index = 0; index < textLength; index++) {
            if (checkedPart.text![index] === '[') {
                openBracketIndexes.push(index);
            }
            else {
                if (checkedPart.text![index] === ']') {
                    closedBracketIndexes.push(index)
                }
            }
        }
        if (openBracketIndexes.length != closedBracketIndexes.length) {
            throw 'Problem part ' + String.fromCharCode(96 + checkedPart.order) + "'s text has mismatching brackets in it resulting in incorrect variable names."
        }
        openBracketIndexes.forEach((value, index) => {
            if (closedBracketIndexes[index] < value) {
                throw 'Problem part ' + String.fromCharCode(96 + checkedPart.order) + "'s text has mismatching brackets in it resulting in incorrect variable names."

            }
            var variableName = checkedPart.text!.substring(value + 1, closedBracketIndexes[index])
            let foundVariableName = false
            if (variableName == "g") {
                foundVariableName = true
            }
            if (!foundVariableName) {
                for (let i = 0; i < variables.length; i++) {
                    if (variables[i].name == variableName) {
                        foundVariableName = true
                        break
                    }
                }
            }
            if (!foundVariableName) {
                throw 'Problem part ' + String.fromCharCode(96 + checkedPart.order) + "'s text contains an invalid variable name [" + variableName + "]. Variable names are case sensitive."
            }
        })
    }

    private isNullOrWhiteSpace(value: string | undefined | null) {
        return typeof (value) === "undefined" || value == null || value.trim().length == 0;
    }

    private isNullOrUndefined(value: any): boolean {
        return typeof (value) === "undefined" || value == null;
    }

}
